import { DateInputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { format } from "date-fns";
import { ChangeEvent, InvalidEvent, JSX, useState } from "react";
import { setFormValues } from "../EditCertificateModalSlice";
import { getValidityPeriodDisplay } from "../../../common/utils/getValidityPeriodDisplay";
import { Dispatch } from "redux";
import { useAssociatedFieldId } from "../../../common/utils/useAssociatedFieldId";

interface Props {
    formValues: {
        validAt: string;
        expiresAt: string;
    };
    dispatch: Dispatch;
}

export const DateInputFieldComponent = (props: Props): JSX.Element => {
    const { formValues, dispatch } = props;
    const [dateError, setDateError] = useState<string | null>();
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-edit-certificate-modal__form-group"}>
            <label htmlFor={fieldId}>Datum behaald</label>
            <div ref={fieldRef}>
                <DateInputField
                    value={formValues?.validAt}
                    max={format(new Date(), "yyyy-MM-dd")}
                    required={true}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        if (dateError) {
                            setDateError(null);
                        }

                        dispatch(
                            setFormValues({
                                ...formValues,
                                validAt: event.target.value,
                            }),
                        );
                    }}
                    onInvalid={(event: InvalidEvent<HTMLInputElement>) => {
                        event.preventDefault();

                        if (
                            (event.target as HTMLInputElement).validity
                                .valueMissing
                        ) {
                            setDateError("Selecteer datum");
                        }
                    }}
                />
            </div>
            {dateError && <p className="c-error-message">{dateError}</p>}
            {formValues?.validAt && formValues.expiresAt && (
                <p
                    className={
                        "c-edit-certificate-modal__form-group__expiry-date"
                    }
                >
                    {
                        getValidityPeriodDisplay({
                            expiresAt: formValues?.expiresAt,
                            isAlreadyFormatted: true,
                        }).text
                    }
                </p>
            )}
        </div>
    );
};
